import styled from 'styled-components';
import { Page } from 'components/molecules/page';

export const SettingsPageContent = styled(Page.Content)`
  padding: 0 var(--layout-01) var(--layout-01) var(--layout-01);
  overflow-y: auto;
  height: 100vh;
  border-radius: 0;
  > .ant-row {
    padding: var(--spacing-03);
  }
`;

export const SettingsPage = styled(Page).attrs({
  $gray: false,
  $overflow: true,
})`
  padding-top: 0;
  padding-bottom: 0;
  height: calc(100vh - 16px);
  border-radius: 0;
  ${Page.Header} {
    border-radius: 0 8px 0 0;
  }
`;
